import React,{Component} from 'react';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import './style.css';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Menu from '@mui/material/Menu';

import MenuList from '@mui/material/MenuList';
class MultiSelect extends Component
{
    state={
        open:false,
        selection:[]
    }
    componentWillReceiveProps(newProps)
    {
        this.setState({selection:newProps.value})
    }
    render()
    {
        
        return <div onClick={()=>{
            if(!this.state.open)
                this.setState({open:!this.state.open})
        }} className={`${this.props.className||""} select-input`}>
            {this.props.renderValue(this.props.value)}
            {(!this.props.value||this.props.value.length===0)&&this.props.placeholder&&<span className="select-input-placeholder">{this.props.placeholder}...</span>}
            {this.state.open&&<Dialog fullWidth={true} size={"md"} open={true} disableBackdropClick={true} disableEscapeKeyDown={true}>
                <DialogTitle>{this.props.placeholder||"Select"}</DialogTitle>
                <DialogContent className="list-container">
                
          {this.props.children.map(item=><MenuItem className={`list-item ${this.state.selection.includes(item.props.value)&&"selected"}`} selected={this.state.selection.includes(item.props.value)} onClick={()=>{
              this.setState({selection:this.state.selection.includes(item.props.value)?this.state.selection.filter(value=>value!=item.props.value):[...this.state.selection,item.props.value]})
          }} value={item.props.value}>{item.props.children}</MenuItem>)}
          
                </DialogContent>
                <DialogActions>
                <Button variant="outlined" color="primary" onClick={()=>this.setState({open:false},()=>this.props.onChange({target:{name:this.props.name,value:this.state.selection}}))}>Save Selection</Button>
                    <Button onClick={()=>this.setState({open:false})}>Close</Button>
                </DialogActions>
            </Dialog>}
        </div>
        
                    
    }
}
export default MultiSelect;